import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import CompanyToken from './company-token';
import CompanyTokenDetail from './company-token-detail';
import CompanyTokenUpdate from './company-token-update';
import CompanyTokenDeleteDialog from './company-token-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={CompanyTokenUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={CompanyTokenUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={CompanyTokenDetail} />
      <ErrorBoundaryRoute path={match.url} component={CompanyToken} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={CompanyTokenDeleteDialog} />
  </>
);

export default Routes;
